import React, { useMemo } from 'react'
import WorkoutDailyfixForm from './_form'

export default function WorkoutDailyfixAdd (props) {
  const data = useMemo(() => ({}), [])
  return (
    <WorkoutDailyfixForm data={data} {...props} />
  )
}